/* eslint-disable @typescript-eslint/no-explicit-any */
import { reportantesApi } from '../../../common/services/apis/reportantesApi.ts';
import { tokenApi } from '../../../common/services/apis/tokenApi.ts';
import { loadReportantes, setReportantes } from '../slices/reportantesSlices.ts';

export const getReportantes = () => {
    return async (dispatch: any) => {

        dispatch(loadReportantes());
        let token = await tokenApi.then((tokenresultado) => tokenresultado);
        const desToken = token.data.split(',');
        const numeroToken=desToken[1].split('=');
        const { data } = await reportantesApi(numeroToken[1]).get(``);
       
        dispatch(setReportantes({ reportantes: ((data)) }));
    }
}